import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { StatusBadgeComponent } from '../../../../parts/status-badge/status-badge.component';
import { DashboardRecentItem } from '../../../../core/models/ui/dashboard.model';
import { DashboardConstants } from '../../../../core/constants/dashboard.constants';
import { OrgDatePipe } from '../../../../core/pipes/org-date/org-date.pipe';

@Component({
	selector: 'ms-dashboard-recent-list',
	imports: [RouterLink, OrgDatePipe, FaDuotoneIconComponent, StatusBadgeComponent],
	templateUrl: './dashboard-recent-list.component.html',
	styleUrl: './dashboard-recent-list.component.scss'
})
export class DashboardRecentListComponent {
	public title = input.required<string>();
	public items = input<DashboardRecentItem[]>([]);
	public isLoading = input<boolean>(false);
	public emptyMessage = input<string>('No items to display.');

	public skeletonRows = Array.from({ length: DashboardConstants.SKELETON_ROWS });
}
